<template>
  <component
    :is="tag || 'div'"
    ref="target"
    :class="[_class.join(' '), isVisible ? 'visible' : '']"
  >
    <slot />
  </component>
</template>

<script setup>
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);
const props = defineProps(["class", "tag", "type", "delay"]);
const _class = ["anim"];
if (props.delay) _class.push("d" + props.delay);
if (props.class) _class.push(props.class);
if (props.type) _class.push(props.type);
else _class.push("t-50");
</script>
